<style>
  :host {
    display: block;
    height: calc(100vh - 180px);
    overflow: hidden;
  }

  .execution-step-node.last-step-node {
    border-left-color: transparent !important;
    padding-bottom: 10px !important;
  }
</style>
<div style="height: 79vh;">
  <div class="repository-tab"
    style="display: flex; height: 100%; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">
    <div class="tc-left"
      style="width: 190px; flex-shrink: 0; display: flex; flex-direction: column; background: #ffffff; border-right: 1px solid #e2e8f0; overflow: hidden; height: 100%;">
      <div class="tc-search-wrap"
        style="padding: 15px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 10px; background: #f8fafc;">
        <i class="fa fa-search" style="color: #94a3b8;"></i>
        <input type="text" class="tc-search-input" placeholder="Search scripts..." [(ngModel)]="tcSearchQuery"
          (ngModelChange)="onSearchChange()"
          style="border: none; background: transparent; outline: none; width: 100%; font-size: 13px;" />
      </div>

      <div class="tc-type-toggle"
        style="display: flex; padding: 8px 10px; gap: 4px; border-bottom: 1px solid #e2e8f0; background: #ffffff;">
        <button type="button" (click)="setScriptListsOf('both')" [class.active]="scriptListsOf === 'both'"
          class="tc-toggle-btn">All</button>
        <button type="button" (click)="setScriptListsOf('image')" [class.active]="scriptListsOf === 'image'"
          class="tc-toggle-btn">Image</button>
        <button type="button" (click)="setScriptListsOf('element')" [class.active]="scriptListsOf === 'element'"
          class="tc-toggle-btn">Element</button>
      </div>

      @if (isScriptsLoading) {
      <div style="text-align: center; padding: 30px 20px; color: #64748b;">
        <i class="fa fa-spinner fa-spin" style="font-size: 24px; margin-bottom: 10px;"></i>
        <p style="font-size: 13px;">Loading scripts...</p>
      </div>
      }

      <div class="tc-list" style="flex: 1; overflow-y: auto;">
        @for (script of filteredTestCases; track script.script_id; let i = $index) {
        <div class="tc-item" [class.active]="selectedScript?.script_id === script.script_id"
          style="padding: 15px; border-bottom: 1px solid #f1f5f9; cursor: pointer;" (click)="selectTestCase(script)">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="font-size: 13px; font-weight: 600; color: #94a3b8;">{{ i + 1 }}.</span>
              <div style="display: flex; flex-direction: column;">
                <div style="font-weight: 500; font-size: 14px; color: #1e293b;">
                  {{ script.script_name || 'Unnamed Script' }}
                </div>
                <span class="tc-type-badge" [class.element]="script.scriptType === 'element'">
                  {{ script.scriptType === 'element' ? 'Element' : 'Image' }}
                </span>
              </div>
            </div>
            <div style="display: flex; gap: 4px;">
              <button (click)="openEditScriptModal(script, $event)" title="Edit Script"
                style="background: none; border: none; padding: 6px; border-radius: 4px; color: #64748b; cursor: pointer; transition: all 0.2s;"
                onmouseover="this.style.background='#e2e8f0'; this.style.color='#1e293b'"
                onmouseout="this.style.background='none'; this.style.color='#64748b'">
                <i class="fa fa-edit" style="font-size: 13px;"></i>
              </button>
              <button (click)="deleteScript(script, $event)" title="Delete Script"
                style="background: none; border: none; padding: 6px; border-radius: 4px; color: #ef4444; cursor: pointer; transition: all 0.2s;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='none'">
                <i class="fa fa-trash" style="font-size: 13px;"></i>
              </button>
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="tc-right"
      style="flex: 2; display: flex; flex-direction: column; background: #ffffff; position: relative; height: 100%;">
      @if (!selectedScript) {
      <div class="center-state"
        style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #94a3b8; background: #f8fafc;">
        <div class="state-icon" style="font-size: 48px; margin-bottom: 16px; opacity: 0.3;"><i
            class="fa fa-code-branch"></i></div>
        <p class="state-msg" style="font-size: 18px; font-weight: 600; color: #475569; margin-bottom: 8px;">Select a
          Script</p>
        <p class="state-hint" style="font-size: 13px; max-width: 300px; text-align: center;">Choose a script from the
          repository list on the left to view its details and execution timeline.</p>
      </div>
      }

      @if (selectedScript && !executionLiveStatus && selectedScriptDetails) {
      <div class="tc-detail"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden; background: #ffffff;">
        <div class="tc-steps-header"
          style="background: #ffffff; padding: 10px 15px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 10px; flex-shrink: 0; flex-wrap: wrap;">
          <h3 style="margin: 0; font-size: 14px; font-weight: 700; color: #0f172a; white-space: nowrap;">{{
            selectedScriptDetails.script_name }}</h3>
          <span
            style="background: #e2e8f0; color: #475569; font-size: 9px; font-weight: 700; padding: 3px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.3px;">{{
            selectedScriptDetails.steps?.length || 0 }} steps</span>
          <span
            style="background: rgba(34,197,94,0.1); color: #16a34a; font-size: 9px; font-weight: 700; padding: 3px 8px; border-radius: 12px; text-transform: uppercase; border: 1px solid rgba(34,197,94,0.2);">Ready</span>

          <div style="margin-left: auto; display: flex; align-items: center; gap: 6px;">
            <div class="info-hover-wrap">
              <button class="info-btn" type="button" title="Script Info">
                <i class="fa fa-info"></i>
              </button>
              <div class="info-popover">
                <h4 class="info-popover-title">Script Info</h4>
                <div class="info-popover-body">
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-envelope"></i> Owner</span>
                    <span class="info-value">{{ selectedScriptDetails.email || 'System' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-mobile"></i> Target</span>
                    <span class="info-value">{{ selectedScriptDetails.mobile_name || 'Device' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-clock"></i> Created</span>
                    <span class="info-value">{{ selectedScriptDetails.created_at | date:'shortDate' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-list-ol"></i> Steps</span>
                    <span class="info-value badge">{{ selectedScriptDetails.steps?.length || 0 }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-tag"></i> Type</span>
                    <span class="info-value">{{ selectedScriptDetails.scriptType === 'element' ? 'Element' : 'Image'
                      }}</span>
                  </div>
                </div>
              </div>
            </div>

            <button (click)="openCapabilitiesEditor()"
              style="background: #fff; color: #475569; border: 1px solid #cbd5e1; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-sliders-h" style="margin-right: 4px; font-size: 10px;"></i>Capabilities
            </button>
            <button (click)="runTestCase(selectedScript)"
              style="background: #167FFC; color: #fff; border: none; border-radius: 5px; padding: 5px 12px; font-weight: 600; cursor: pointer; font-size: 11px;">
              <i class="fa fa-play" style="margin-right: 4px; font-size: 10px;"></i>Run
            </button>
          </div>
        </div>

        <div class="timeline-body"
          style="flex: 1; overflow-y: auto; padding: 15px 15px 50px 15px; background: #ffffff;">
          @if (!selectedScriptDetails.steps || selectedScriptDetails.steps.length === 0) {
          <div class="empty-timeline" style="text-align: center; color: #94a3b8; font-style: italic; margin-top: 40px;">
            No execution steps recorded for this script.</div>
          } @else {
          <div class="timeline-container"
            style="display: flex; flex-direction: column; gap: 0; max-width: 900px; margin: 0 auto;">
            @for (step of selectedScriptDetails.steps; track step.step || $index; let isLast = $last) {
            <div class="execution-step-node" [class.last-step-node]="isLast"
              style="position: relative; padding-left: 35px; padding-bottom: 44px; border-left: 2px solid #e2e8f0; margin-left: 14px;">
              @if (isLast) { <div style="position: absolute; left: -2px; top: 0; width: 2px; height: 12px; z-index: 1;"
                [style.background]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#22c55e' : (step.status === 'FAILED' ? '#ef4444' : (step.status === 'RUNNING' ? '#167FFC' : '#e2e8f0'))">
              </div> }

              <div class="timeline-dot"
                style="position: absolute; left: -13px; top: 0; width: 24px; height: 24px; border-radius: 50%; background: #ffffff; border: 2px solid #cbd5e1; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0,0,0,0.06); font-size: 11px; font-weight: 700; color: #64748b; z-index: 2;">
                {{ step.step }}
              </div>

              <div
                style="background: #ffffff; border-radius: 6px; box-shadow: 0 1px 4px rgba(15,23,42,0.04); border: 1px solid #e2e8f0; padding: 12px; margin-top: -4px; transition: all 0.2s;"
                onmouseover="this.style.borderColor='#cbd5e1'; this.style.boxShadow='0 4px 12px rgba(15,23,42,0.08)'"
                onmouseout="this.style.borderColor='#e2e8f0'; this.style.boxShadow='0 2px 8px rgba(15,23,42,0.04)'">
                <div style="display: flex; align-items: flex-start; gap: 20px;">

                  @if (step.image_id && loadedImages[step.image_id]) {
                  <div
                    style="flex-shrink: 0; width: 48px; height: 48px; overflow: hidden; border-radius: 6px; border: 1px solid #e2e8f0; cursor: zoom-in; background: #f8fafc;"
                    (click)="zoomImageUrl = loadedImages[step.image_id]" onmouseover="this.style.borderColor='#167FFC'"
                    onmouseout="this.style.borderColor='#e2e8f0'">
                    <img [src]="loadedImages[step.image_id]" alt="Step Preview"
                      style="width: 100%; height: 100%; object-fit: cover; display: block;">
                  </div>
                  } @else if (step.image_id && !loadedImages[step.image_id]) {
                  <div
                    style="flex-shrink: 0; width: 48px; height: 48px; border-radius: 6px; border: 1px dashed #cbd5e1; background: #f8fafc; display: flex; align-items: center; justify-content: center; color: #94a3b8;"
                    title="Loading...">
                    <i class="fa fa-spinner fa-spin" style="font-size: 14px; opacity: 0.5;"></i>
                  </div>
                  }

                  <div style="display: flex; flex-direction: column; gap: 8px; flex-grow: 1;">
                    <div class="content-header" style="margin-bottom: 2px;">
                      <div class="element-name"
                        style="font-size: 16px; font-weight: 700; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                        {{ step.element_name || step.action || 'Unnamed Step' }}
                        <button (click)="openEditStepModal(step, $event)" title="Edit Step"
                          style="background: none; border: none; font-size: 13px; color: #94a3b8; cursor: pointer; padding: 2px;"
                          onmouseover="this.style.color='#167FFC'" onmouseout="this.style.color='#94a3b8'"><i
                            class="fa fa-edit"></i></button>
                        <button (click)="deleteStep(step, $event)" title="Delete Step"
                          style="background: none; border: none; font-size: 13px; color: #94a3b8; cursor: pointer; padding: 2px;"
                          onmouseover="this.style.color='#ef4444'" onmouseout="this.style.color='#94a3b8'"><i
                            class="fa fa-trash"></i></button>
                      </div>
                    </div>

                    <div class="step-attributes"
                      style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
                      <span
                        style="background: #eff6ff; color: #2563eb; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; border: 1px solid #bfdbfe;">
                        <i class="fa fa-bolt" style="margin-right: 4px; opacity: 0.7;"></i> {{ step.action }}
                      </span>
                      @if (step.confidence) {
                      <span
                        style="background: #f0fdf4; color: #16a34a; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; border: 1px solid #bbf7d0;">
                        <i class="fa fa-bullseye" style="margin-right: 4px; opacity: 0.7;"></i> {{ (step.confidence *
                        100) }}%
                      </span>
                      }
                      <span style="font-size: 11px; font-family: monospace; color: #64748b; padding: 4px 0;">
                        ID: {{ step.image_id || 'N/A' }}
                      </span>
                    </div>

                    @if (step.value) {
                    <div class="input-value-block"
                      style="margin-top: 6px; font-size: 13px; color: #334155; background: #f8fafc; padding: 10px 14px; border-radius: 6px; border-left: 3px solid #167FFC;">
                      <strong style="color: #1e293b; margin-right: 4px;">Input Data:</strong> <span
                        style="font-family: monospace;">{{ step.value }}</span>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }

      @if (selectedScript && executionLiveStatus) {
      <div class="tc-detail"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden; background: #ffffff;">
        <div class="tc-steps-header"
          style="background: #ffffff; padding: 10px 15px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 10px; flex-shrink: 0; flex-wrap: wrap;">
          <h3 style="margin: 0; font-size: 14px; font-weight: 700; color: #0f172a; white-space: nowrap;">{{
            selectedScript.script_name }}</h3>
          <span
            style="background: #eff6ff; color: #2563eb; font-size: 9px; font-weight: 800; padding: 3px 8px; border-radius: 12px; text-transform: uppercase; border: 1px solid #bfdbfe;">
            <i class="fa fa-circle" style="margin-right: 3px; font-size: 6px; animation: pulse 1.5s infinite;"></i>{{
            executionLiveStatus }}
          </span>

          <div style="margin-left: auto; display: flex; align-items: center; gap: 6px;">
            <div class="info-hover-wrap">
              <button class="info-btn" type="button" title="Script Info">
                <i class="fa fa-info"></i>
              </button>
              <div class="info-popover">
                <h4 class="info-popover-title">Script Info</h4>
                <div class="info-popover-body">
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-envelope"></i> Owner</span>
                    <span class="info-value">{{ selectedScriptDetails?.email || 'System' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-mobile"></i> Target</span>
                    <span class="info-value">{{ selectedScriptDetails?.mobile_name || 'Device' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-clock"></i> Created</span>
                    <span class="info-value">{{ selectedScriptDetails?.created_at | date:'shortDate' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-list-ol"></i> Steps</span>
                    <span class="info-value badge">{{ selectedScriptDetails?.steps?.length || 0 }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fa fa-tag"></i> Type</span>
                    <span class="info-value">{{ selectedScriptDetails?.scriptType === 'element' ? 'Element' : 'Image'
                      }}</span>
                  </div>
                </div>
              </div>
            </div>

            <button (click)="openCapabilitiesEditor()"
              style="background: #fff; color: #475569; border: 1px solid #cbd5e1; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-sliders-h" style="margin-right: 4px; font-size: 10px;"></i>Capabilities
            </button>

            @if (executionLiveStatus === 'RUNNING' || executionLiveStatus === 'PAUSED') {
            <button (click)="stopExecution()"
              style="background: #fff; color: #ef4444; border: 1px solid #fca5a5; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-stop" style="margin-right: 4px; font-size: 10px;"></i>Stop
            </button>
            }

            @if (executionLiveStatus === 'RUNNING') {
            <button (click)="pauseExecution()"
              style="background: #fff; color: #ca8a04; border: 1px solid #fde047; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#fef9c3'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-pause" style="margin-right: 4px; font-size: 10px;"></i>Pause
            </button>
            }

            @if (executionLiveStatus === 'PAUSED') {
            <button (click)="resumeExecution()"
              style="background: #fff; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-play" style="margin-right: 4px; font-size: 10px;"></i>Resume
            </button>
            }

            <button (click)="runTestCase(selectedScript)"
              style="background: #fff; color: #dc2626; border: 1px solid #fca5a5; border-radius: 5px; padding: 5px 10px; font-weight: 600; cursor: pointer; font-size: 11px;"
              onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='#fff'">
              <i class="fa fa-redo" style="margin-right: 4px; font-size: 10px;"></i>Restart
            </button>
          </div>
        </div>

        @if (scriptSteps.length === 0) {
        <div class="center-state"
          style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #94a3b8;">
          <div class="state-icon" style="font-size: 48px; margin-bottom: 16px; opacity: 0.5; color: #167FFC;"><i
              class="fa fa-spinner fa-spin"></i></div>
          <p class="state-msg" style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 8px;">Preparing
            Runtime Pipeline</p>
          <p class="state-hint" style="font-size: 13px; max-width: 300px; text-align: center;">Connecting websocket
            pipes and initializing target automation actions...</p>
        </div>
        }

        @if (scriptSteps.length > 0) {
        <div class="tc-steps-wrap"
          style="flex: 1; overflow-y: auto; padding: 15px; min-height: 0; background: #ffffff;">
          <div class="script-execution-list"
            style="display: flex; flex-direction: column; gap: 0; max-width: 900px; margin: 0 auto;">
            @for (step of scriptSteps; track step.step || $index; let isLast = $last) {
            <div class="execution-step-node" [id]="'step-' + step.step" [class.last-step-node]="isLast"
              style="position: relative; padding-left: 35px; margin-left: 14px; padding-bottom: 44px;"
              [style.border-left]="'2px solid ' + (step.status === 'SUCCESS' || step.status === 'PASSED' ? '#22c55e' : (step.status === 'FAILED' ? '#ef4444' : (step.status === 'RUNNING' ? '#167FFC' : '#e2e8f0')))">

              @if (isLast) { <div style="position: absolute; left: -2px; top: 0; width: 2px; height: 12px; z-index: 1;"
                [style.background]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#22c55e' : (step.status === 'FAILED' ? '#ef4444' : (step.status === 'RUNNING' ? '#167FFC' : '#e2e8f0'))">
              </div> }

              <div
                style="position: absolute; left: -13px; top: 0; width: 24px; height: 24px; border-radius: 50%; background: #ffffff; border: 2px solid #cbd5e1; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0,0,0,0.06); z-index: 2;"
                [style.border-color]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#22c55e' : (step.status === 'FAILED' ? '#ef4444' : (step.status === 'RUNNING' ? '#167FFC' : '#cbd5e1'))">
                @if (step.status === 'SUCCESS' || step.status === 'PASSED') {
                <i class="fa fa-check" style="color: #22c55e; font-size: 10px;"></i>
                } @else if (step.status === 'FAILED') {
                <i class="fa fa-times" style="color: #ef4444; font-size: 10px;"></i>
                } @else if (step.status === 'RUNNING') {
                <i class="fa fa-spinner fa-spin" style="color: #167FFC; font-size: 10px;"></i>
                } @else if (step.step === -1) {
                <i class="fa fa-cogs" style="color: #64748b; font-size: 10px;"></i>
                } @else {
                <span style="font-size: 10px; font-weight: 700; color: #64748b;">{{ step.step }}</span>
                }
              </div>

              <div
                style="background: #ffffff; border-radius: 6px; box-shadow: 0 1px 4px rgba(15,23,42,0.04); border: 1px solid #e2e8f0; padding: 12px; margin-top: -4px; transition: all 0.2s;"
                [style.border-color]="step.status === 'RUNNING' ? '#167FFC' : '#e2e8f0'"
                [style.box-shadow]="step.status === 'RUNNING' ? '0 0 0 1px #167FFC, 0 4px 12px rgba(22,127,252,0.1)' : ''">

                <div style="display: flex; align-items: flex-start; gap: 20px;">

                  @if (step.image_id && loadedImages[step.image_id]) {
                  <div
                    style="flex-shrink: 0; width: 48px; height: 48px; overflow: hidden; border-radius: 6px; border: 1px solid #e2e8f0; cursor: zoom-in; background: #f8fafc;"
                    (click)="zoomImageUrl = loadedImages[step.image_id]" onmouseover="this.style.borderColor='#167FFC'"
                    onmouseout="this.style.borderColor='#e2e8f0'">
                    <img [src]="loadedImages[step.image_id]" alt="Step Preview"
                      style="width: 100%; height: 100%; object-fit: cover; display: block;">
                  </div>
                  } @else if (step.image_id && !loadedImages[step.image_id]) {
                  <div
                    style="flex-shrink: 0; width: 48px; height: 48px; border-radius: 6px; border: 1px dashed #cbd5e1; background: #f8fafc; display: flex; align-items: center; justify-content: center; color: #94a3b8;"
                    title="Loading...">
                    <i class="fa fa-spinner fa-spin" style="font-size: 14px; opacity: 0.5;"></i>
                  </div>
                  }

                  <div style="display: flex; flex-direction: column; gap: 8px; flex-grow: 1;">
                    <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                      <div>
                        <div
                          style="font-size: 16px; font-weight: 700; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                          {{ step.element_name || step.action || 'Unnamed Step' }}
                          @if (step.step !== -1) {
                          <button (click)="openEditStepModal(step, $event)" title="Edit Step"
                            style="background: none; border: none; font-size: 13px; color: #94a3b8; cursor: pointer; padding: 2px;"
                            onmouseover="this.style.color='#167FFC'" onmouseout="this.style.color='#94a3b8'"><i
                              class="fa fa-edit"></i></button>
                          <button (click)="deleteStep(step, $event)" title="Delete Step"
                            style="background: none; border: none; font-size: 13px; color: #94a3b8; cursor: pointer; padding: 2px;"
                            onmouseover="this.style.color='#ef4444'" onmouseout="this.style.color='#94a3b8'"><i
                              class="fa fa-trash"></i></button>
                          }
                        </div>
                        <div style="display: flex; gap: 10px; align-items: center; margin-top: 6px; flex-wrap: wrap;">
                          <span
                            style="background: #eff6ff; color: #2563eb; padding: 3px 8px; border-radius: 20px; font-size: 10px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; border: 1px solid #bfdbfe;">
                            <i class="fa fa-bolt" style="margin-right: 4px; opacity: 0.7;"></i> {{ step.action }}
                          </span>
                          @if (step.confidence) {
                          <span
                            style="background: #f0fdf4; color: #16a34a; padding: 3px 8px; border-radius: 20px; font-size: 10px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; border: 1px solid #bbf7d0;">
                            <i class="fa fa-bullseye" style="margin-right: 4px; opacity: 0.7;"></i> {{ (step.confidence
                            * 100) }}%
                          </span>
                          }
                          <span style="font-size: 10px; font-family: monospace; color: #64748b; padding: 3px 0;">
                            ID: {{ step.image_id || 'N/A' }}
                          </span>
                        </div>
                      </div>
                      <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px;">
                        <span
                          style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 20px; border: 1px solid transparent; text-transform: uppercase; letter-spacing: 0.5px;"
                          [style.background]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#f0fdf4' : (step.status === 'FAILED' ? '#fef2f2' : (step.status === 'RUNNING' ? '#eff6ff' : '#f8fafc'))"
                          [style.color]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#16a34a' : (step.status === 'FAILED' ? '#dc2626' : (step.status === 'RUNNING' ? '#2563eb' : '#64748b'))"
                          [style.borderColor]="step.status === 'SUCCESS' || step.status === 'PASSED' ? '#bbf7d0' : (step.status === 'FAILED' ? '#fecaca' : (step.status === 'RUNNING' ? '#bfdbfe' : '#e2e8f0'))">
                          {{ step.status || 'PENDING' }}
                        </span>
                        <button (click)="toggleStepExpand(step.step)"
                          style="background: transparent; border: none; color: #64748b; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 4px; padding: 4px; transition: color 0.2s;"
                          onmouseover="this.style.color='#1e293b'" onmouseout="this.style.color='#64748b'">
                          <i class="fa fa-terminal"></i> <span>Logs</span>
                          <i class="fa"
                            [ngClass]="expandedStepIndex === step.step ? 'fa-chevron-up' : 'fa-chevron-down'"
                            style="font-size: 10px;"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                @if (step.error) {
                <div
                  style="background: #fef2f2; border: 1px solid #fecaca; padding: 12px 16px; border-radius: 6px; margin-top: 15px; font-size: 13px; color: #dc2626; display: flex; align-items: flex-start; gap: 10px;">
                  <i class="fa fa-exclamation-circle" style="margin-top: 2px; font-size: 16px;"></i>
                  <div>
                    <strong style="display: block; margin-bottom: 4px; font-size: 14px;">Execution Failure</strong>
                    <span style="font-family: monospace; font-size: 12px; word-break: break-all;">{{ step.error
                      }}</span>
                  </div>
                </div>
                }

                @if (expandedStepIndex === step.step) {
                <div class="step-live-events-feed"
                  style="margin-top: 15px; background: #f8fafc; padding: 15px; border-radius: 6px; max-height: 250px; overflow-y: auto; border: 1px solid #e2e8f0; box-shadow: inset 0 2px 4px rgba(0,0,0,0.02);">
                  @if (!step.logs || step.logs.length === 0) {
                  <div
                    style="font-family: monospace; font-size: 12px; color: #94a3b8; font-style: italic; text-align: center; padding: 10px;">
                    Waiting for execution telemetry log messages...
                  </div>
                  }
                  @for (log of step.logs; track $index) {
                  <div
                    style="font-family: monospace; font-size: 12px; color: #475569; padding: 4px 0; border-bottom: 1px solid #f1f5f9; line-height: 1.5; white-space: pre-wrap; word-break: break-all; overflow-wrap: anywhere;">
                    <span style="color: #2563eb; margin-right: 8px; font-weight: bold;">></span>{{ log }}
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        }

        <div class="tc-steps-footer"
          style="font-weight: 600; background: #ffffff; padding: 12px 20px; color: #475569; display: flex; justify-content: space-between; align-items: center; font-size: 13px; border-top: 1px solid #e2e8f0; flex-shrink: 0;">
          <span>Execution Progress Metrics</span>
          <span
            style="background: #eff6ff; color: #2563eb; padding: 4px 12px; border-radius: 20px; font-weight: 700;">{{
            passedStepsCount() }} / {{ scriptSteps.length }} Successful</span>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<ng-template #capsModalTemplate>
  <div style="padding: 20px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h3 style="margin: 0; font-size: 16px; font-weight: 700; color: #0f172a;"><i class="fa fa-sliders-h"
          style="margin-right: 8px; color: #167FFC;"></i>Device Capabilities</h3>
      <button (click)="closeCapabilitiesEditor()"
        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #94a3b8; padding: 4px;">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
      <button type="button" (click)="fetchPackageDetails()"
        style="background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 5px; padding: 6px 12px; font-weight: 600; cursor: pointer; font-size: 12px; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <i class="fa fa-search"></i> Get Package
      </button>
    </div>

    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">App
        Package</label>
      <input [(ngModel)]="capEditPackageName" (ngModelChange)="syncCapsToJson()" placeholder="com.example.app"
        style="width: 100%; padding: 8px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box;" />
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">App
        Activity</label>
      <input [(ngModel)]="capEditAppName" (ngModelChange)="syncCapsToJson()" placeholder="com.example.app.MainActivity"
        style="width: 100%; padding: 8px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box;" />
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">Raw
        JSON</label>
      <textarea [(ngModel)]="capEditRawJson" (ngModelChange)="onCapJsonChange()" rows="10"
        style="width: 100%; padding: 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-family: monospace; font-size: 12px; outline: none; resize: vertical; box-sizing: border-box; background: #f8fafc;"></textarea>
    </div>
    @if (capJsonError) {
    <div
      style="color: #dc2626; font-size: 12px; margin-bottom: 10px; padding: 6px 10px; background: #fef2f2; border-radius: 4px;">
      {{ capJsonError }}</div>
    }
    <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 8px;">
      <button (click)="closeCapabilitiesEditor()"
        style="background: #fff; color: #475569; border: 1px solid #cbd5e1; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Cancel</button>
      <button (click)="saveCapabilities()"
        style="background: #167FFC; color: #fff; border: none; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Save</button>
    </div>
  </div>
</ng-template>

@if (zoomImageUrl) {
<div
  style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(15,23,42,0.85); z-index: 999999; display: flex; justify-content: center; align-items: center; cursor: zoom-out;"
  (click)="zoomImageUrl = null">
  <img [src]="zoomImageUrl"
    style="max-width: 90vw; max-height: 90vh; border-radius: 8px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5); object-fit: contain;"
    (click)="$event.stopPropagation()">
</div>
}

<ng-template #editScriptModalTemplate>
  <div style="padding: 20px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h3 style="margin: 0; font-size: 16px; font-weight: 700; color: #0f172a;"><i class="fa fa-edit"
          style="margin-right: 8px; color: #167FFC;"></i>Edit Script Details</h3>
      <button (click)="closeEditScriptModal()"
        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #94a3b8; padding: 4px;">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">Script
        Name</label>
      <input [(ngModel)]="editScriptName" placeholder="Enter script name"
        style="width: 100%; padding: 8px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box;" />
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">Target
        Device Name</label>
      <input [(ngModel)]="editScriptMobile" placeholder="Enter device name"
        style="width: 100%; padding: 8px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box;" />
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">Steps Data
        (JSON)</label>
      <textarea [(ngModel)]="editScriptStepsJson" (ngModelChange)="onEditScriptJsonChange()" rows="10"
        style="width: 100%; padding: 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-family: monospace; font-size: 12px; outline: none; resize: vertical; box-sizing: border-box; background: #f8fafc;"></textarea>
      @if (editScriptJsonError) {
      <div
        style="color: #dc2626; font-size: 12px; margin-top: 6px; padding: 6px 10px; background: #fef2f2; border-radius: 4px;">
        {{ editScriptJsonError }}</div>
      }
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
      <button (click)="closeEditScriptModal()"
        style="background: #fff; color: #475569; border: 1px solid #cbd5e1; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Cancel</button>
      <button (click)="saveScriptDetails()"
        style="background: #167FFC; color: #fff; border: none; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Save</button>
    </div>
  </div>
</ng-template>

<ng-template #editStepModalTemplate>
  <div style="padding: 20px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h3 style="margin: 0; font-size: 16px; font-weight: 700; color: #0f172a;"><i class="fa fa-edit"
          style="margin-right: 8px; color: #167FFC;"></i>Edit Step Data</h3>
      <button (click)="closeEditStepModal()"
        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #94a3b8; padding: 4px;">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div style="margin-bottom: 12px;">
      <label style="font-size: 12px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block;">Step JSON
        Data</label>
      <textarea [(ngModel)]="editSingleStepJson" (ngModelChange)="onEditSingleStepJsonChange()" rows="15"
        style="width: 100%; padding: 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-family: monospace; font-size: 12px; outline: none; resize: vertical; box-sizing: border-box; background: #f8fafc;"></textarea>
      @if (editSingleStepError) {
      <div
        style="color: #dc2626; font-size: 12px; margin-top: 6px; padding: 6px 10px; background: #fef2f2; border-radius: 4px;">
        {{ editSingleStepError }}</div>
      }
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
      <button (click)="closeEditStepModal()"
        style="background: #fff; color: #475569; border: 1px solid #cbd5e1; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Cancel</button>
      <button (click)="saveSingleStep()"
        style="background: #167FFC; color: #fff; border: none; border-radius: 5px; padding: 7px 16px; font-weight: 600; cursor: pointer; font-size: 12px;">Save
        Step</button>
    </div>
  </div>
</ng-template>

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>